import { useEffect, useState } from 'react'
import Tabs from '../../../../../Components/Tabs'
import GetIcon from '../../../../../utils/Icon'
import { NavLink, useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Table from './Table'
import { usePostItemListMutation, } from "../../../../../store/api/purchaseorderapi";
import {
    usePostFrappeClientGetMutation,
    usePostSalesOrderCreateMutation, usePostSalesOrderSubmitMutation,
    usePostSalesOrderUpdateMutation
} from "../../../../../store/api/salesorderapi";
import { usePostCreatePicklistMutation } from "../../../../../store/api/picklist";
import Button from '../../../../../Core/Button/Button'
import ApiResponseBox from '../../../../../Components/ApiResponseBox'
import BulkUpload from './BulkUpload'
import { useGetPaymentTermsQuery } from '../../../../../store/api/paymenttermapi'
import { useGetCurrencyListQuery, useGetSelectedCompanyQuery } from '../../../../../store/api/companyapi'
import { useGetPriceListQuery } from "../../../../../store/api/pricelistapi";
import { useGetSalesTaxCategoryListQuery, useGetTaxCategoryListQuery } from "../../../../../store/api/taxcategoryapi";
import { useGetTermsandConditionQuery } from "../../../../../store/api/termsandconditionapi";
import { useGetCostCenterListQuery } from "../../../../../store/api/costcenterapi";
import { useGetProjectListQuery } from "../../../../../store/api/projectapi";
import Attachment from '../../../../../utils/Attachment'


function Salesform() {
    const [postSalesOrderCreate] = usePostSalesOrderCreateMutation();
    const [postSalesOrderupdate] = usePostSalesOrderUpdateMutation();



    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [rows, setRows] = useState([{
        item_code: "",
        item: {},
        required_by: "",
        quantity: 1,
        uom: "",
        rate: "0",
        amount: "0",
    }]);
    const [tab, settab] = useState(1)
    const [ptype, setptype] = useState("Error ")
    const [showpopup, setShowpopup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [fullData, setfullData] = useState(null);
    console.log("check full data is ehr",fullData);
    const { data: p_term } = useGetPaymentTermsQuery();
    const { data: pricelist } = useGetPriceListQuery({ filters: JSON.stringify({ selling: 1 }) });
  const [sodate, setsodate] = useState(new Date().toISOString().split('T')[0])
    const { data: currencylist } = useGetCurrencyListQuery();
    const { data } = useGetSelectedCompanyQuery();
    const selectedComapny = data?.message?.data?.company;
    const { data: taxandchangeslist } = useGetSalesTaxCategoryListQuery(selectedComapny);
    // const { data: taxandchangeslist } = useGetTaxCategoryListQuery();
    const { data: tandc } = useGetTermsandConditionQuery();
    const [postFrappeClientGet] = usePostFrappeClientGetMutation();
    const filters = [
    ["company", "=", selectedComapny?.split(" - ")[0]],
    ["disabled", "=", 0],
    ["is_group", "=", 0]
  ];
    const { data: costcenterlist,refetch:refetchCC } = useGetCostCenterListQuery({filters: JSON.stringify(filters)});

    useEffect(()=>{
        refetchCC();
    },[selectedComapny])
    const { data: projectlist } = useGetProjectListQuery();


    const [fieldErrors, setFieldErrors] = useState({
        customer: false,
        dueDate: false,
        billing_address: false,
        shipping_address: false,
        billingType: false,
        order_type: false,
        items: false
    });


    const [po_response, setpo_response] = useState("");
    const [getitem_list_data] = usePostItemListMutation();
    // console.log("po_responsepo_responsepo_responsepo_response",po_response);

    const [selected_item_data, setselected_item_data] = useState([]);
    const totalQuantity = selected_item_data.reduce((total, item) => {
        return total + parseFloat(item.quantity || 0);
    }, 0)


    const [showDropdown, setShowDropdown] = useState(false);
    const handleNavigate = (path) => {
        nvg(path);
        setShowDropdown(false);
    };

    const [tab1Data, setTab1Data] = useState({});
    const [tab2Data, setTab2Data] = useState({});
    const [tab1CustomerData, setTab1CustomerData] = useState({});
    const [orderNo, setorderNo] = useState('');
    const [termsandcondition, settermsandcondition] = useState([]);
    const [taxandchanges, settaxandchanges] = useState('');
    const [paymentterm, setpaymentterm] = useState([]);
    const [currency, setcurrency] = useState('INR');
    const [pricel, setpricel] = useState('Standard Selling');
    const [project, setproject] = useState('');
    const [cost_center, setcost_center] = useState('');




    function toTitleCase(str) {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }


    const handleSave = async () => {

        const errors = {
            customer: !tab1Data.customer,
            dueDate: !tab1Data.dueDate,
            billing_address: !tab2Data.billing_address,
            shipping_address: !tab2Data.shipping_addresses,
            billingType: !tab1Data.billingType,
            order_type: !tab1Data.order_type,
            items: selected_item_data.length === 0 || selected_item_data.some(item => !item.item_code || !item.quantity)
        };

        setFieldErrors(errors);

        const missingFields = [];

        if (errors.customer) missingFields.push("Customer,");
        if (errors.delivery_date) missingFields.push("Delivery Date,");
        if (errors.billing_address) missingFields.push("Billing Address,");
        if (errors.shipping_address) missingFields.push("Shipping Address,");
        if (errors.custom_billing_type) missingFields.push("Billing Type,");
        if (errors.order_type) missingFields.push("Order Type,");
        if (errors.items) missingFields.push("At least one valid item (with code and quantity),");

        if (missingFields.length > 0) {
            setError(missingFields);
            setptype('Error')
            setShowError(true);
            return;
        }


        const payload = {
            date: tab1Data.date || "",
            customer: tab1Data.customer?.split(" - ")[0] || "",
            delivery_date: tab1Data.dueDate || "",
            items: selected_item_data.map(item => ({
                item_code: item.item_code,
                quantity: parseInt(item.quantity) || 1,
                rate: item.rate == "0" ? item.item.selling_price : item.rate 
            })),
            billing_address: tab2Data.billing_address || "",
            shipping_address: tab2Data.shipping_addresses || "",
            custom_billing_type: tab1Data.billingType ? toTitleCase(tab1Data.billingType) : "",
            order_type: tab1Data.order_type ? toTitleCase(tab1Data.order_type) : "",
            "currency": currency,
            "price_list": pricel,
            "cost_center": cost_center,
            "project": project,
            "tax_category": taxandchanges,
            "payment_terms_template": paymentterm,
            "terms_and_conditions": termsandcondition,

        };


        try {
            const response = await postSalesOrderCreate(payload).unwrap();


            setpo_response(response);
            setorderNo(response.data);
            setItem(true);
             const payload222 = {
                    doctype: 'Sales Order',
                    name: response.data,
                };

            const res1 = await postFrappeClientGet(payload222).unwrap();
            setfullData(res1);
            console.log("postFrappeClientGetpostFrappeClientGetpostFrappeClientGet",res1);
            setError(`Sales Order Saved ${response.data}`);
            setptype('Created');
            setShowError(true);
            console.log("Order No:", response.data);

        } catch (err) {
            console.error("API Error:", err);

            const apiErrors = [];

            if (err?.data?.message) {
                apiErrors.push(err.data.message);
            } else if (err?.message) {
                apiErrors.push(err.message);
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
    };


    const handleUpdate = async () => {

        const errors = {
            name: !orderNo,
            customer: !tab1Data.customer,
            dueDate: !tab1Data.dueDate,
            billing_address: !tab2Data.billing_address,
            shipping_address: !tab2Data.shipping_addresses,
            billingType: !tab1Data.billingType,
            order_type: !tab1Data.order_type,
            items: selected_item_data.length === 0 || selected_item_data.some(item => !item.item_code || !item.quantity)
        };

        setFieldErrors(errors);

        const missingFields = [];

        if (errors.customer) missingFields.push("Customer,");
        if (errors.delivery_date) missingFields.push("Delivery Date,");
        if (errors.billing_address) missingFields.push("Billing Address,");
        if (errors.shipping_address) missingFields.push("Shipping Address,");
        if (errors.custom_billing_type) missingFields.push("Billing Type,");
        if (errors.order_type) missingFields.push("Order Type,");
        if (errors.items) missingFields.push("At least one valid item (with code and quantity),");
        if (errors.name) missingFields.push(" Sales Order No");
        if (missingFields.length > 0) {
            setError(missingFields);
            setptype('Error This field is required')
            setShowError(true);
            return;
        }


        const payload = {
            name: orderNo,
            date: tab1Data.date || "",
            customer: tab1Data.customer?.split(" - ")[0] || "",
            delivery_date: tab1Data.dueDate || "",
            items: selected_item_data.map(item => ({
                item_code: item.item_code,
                quantity: parseInt(item.quantity) || 1
            })),
            billing_address: tab2Data.billing_address || "",
            shipping_address: tab2Data.shipping_addresses || "",
            custom_billing_type: tab1Data.billingType ? toTitleCase(tab1Data.billingType) : "",
            order_type: tab1Data.order_type ? toTitleCase(tab1Data.order_type) : "",
            "currency": currency,
            "price_list": pricel,
            "cost_center": cost_center,
            "project": project,
            "tax_category": taxandchanges,
            "payment_terms_template": paymentterm,
            "terms_and_conditions": termsandcondition,
        };


        try {
            const response = await postSalesOrderupdate(payload).unwrap();

               const payload222 = {
                    doctype: 'Sales Order',
                    name: orderNo,
                };

            const res1 = await postFrappeClientGet(payload222).unwrap();
            setfullData(res1);
            setpo_response(response);
            setorderNo(response.data);
            setItem(true);



            setError(`Sales Order Updated ${response.data}`);
            setptype('Updated');
            setShowError(true);
            console.log("Order No:", response.data);

        } catch (err) {
            console.error("API Error:", err);

            const apiErrors = [];

            if (err?.data?.message) {
                apiErrors.push(err.data.message);
            } else if (err?.message) {
                apiErrors.push(err.message);
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
    };

    const [activityboll, setactivityboll] = useState(false)
    const [submitSalesOrder] = usePostSalesOrderSubmitMutation();

    const handleSubmit = async () => {
        const payload = { sales_order_name: orderNo };

        try {
            const res = await submitSalesOrder(payload);

            // Check if response contains an error message
            if (res.status === 400) {
                // Handle the specific error returned by the API
                const errorMessage = res?.data?.message || 'Unexpected error occurred';
                setError('Error');
                setptype(errorMessage);
                setShowError(true);
                console.error('Error message from API:', errorMessage);
                return;  // Stop further execution
            }

            const payload222 = {
                    doctype: 'Sales Order',
                    name: po_response.data,
                };

            const res1 = await postFrappeClientGet(payload222).unwrap();
            setfullData(res1);

            // Success
            setButtonData(true);
            setactivityboll(true);
            setError('submitted');
            setptype('Sales Order submitted');
            setShowError(true);

        } catch (err) {
            // If there’s a network error or any other error in the request
            console.error("Error caught:", err);
            const errorMessage = err?.data?.message || 'Unexpected error occurred';
            setError('Error');
            setptype(errorMessage);
            setShowError(true);
        }
    };


    const handleMenuItemClick = async () => {
        await handleCreatePicklist();
    };


    const handleCreatePicklist = () => {
        nvg('/outbound/pick/createpick', {
            state: {
                order_id: orderNo
            }
        });
    };




    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between " style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/outbound-sales-order')}>Sales Order List </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }} >
                        New Sales Order
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {buttonData ? 'Submitted' : item ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>

                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    
                    {item && buttonData && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleMenuItemClick}
                        >
                            Create Pick List
                        </Button>
                    )}



                   {/* {item && buttonData && (
                            <div style={{ position: 'relative', display: 'inline-block', height: '28px' }}>
                                <NavLink
                                    onClick={() => setShowDropdown(prev => !prev)}
                                    className="createbutton m-0"
                                    style={{ color: "#391F84", borderRadius: "3px", cursor: 'pointer', height: '28px' }}
                                >
                                    Create
                                    <span className="iconbox ps-2">
                                        <GetIcon iconName="IoMdArrowDropdown" size={14} />
                                    </span>
                                </NavLink>

                                {showDropdown && (
                                    <div className="create-dropdown">
                                        <div onClick={handleMenuItemClick} className="menu-item">
                                            Pick List
                                        </div>
                                        <div onClick={() => nvg('/sales')} className="menu-item">Sales Invoice</div>
                                        <div 
                                         className="menu-item">Material Request</div>
                                        <div
                                          className="menu-item">Request for Raw Materials</div>
                                    </div>
                                )}
                            </div>
                        )} */}


                        

                    {!(item && buttonData) && (
                    <Button
                        className="custom-btn-bluecolor d-flex"
                        iconName="BiCloudUpload"
                        style={{ gap: '2px' }}
                        iconSize={14}
                        onClick={() => { setShowpopup(true) }}
                    >
                        Upload
                    </Button>)}

                    {orderNo && !buttonData && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleUpdate}
                        >
                            Update
                        </Button>
                    )}

                    {item && !buttonData ? (
                        <Button
                            className="custom-btn-00989"
                            onClick={handleSubmit}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}

                        >
                            Submit

                        </Button>
                    ) : item && buttonData ? (
                        ''
                    ) : (
                        <Button
                            className="custom-btn-00989"
                            onClick={handleSave}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}

                        >
                            Save
                        </Button>

                    )}
                   

                </div>

            </div>
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                                    Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>

                        </ul>
                        {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "3px", color: "#391F84" }}>
                            <span>
                                <GetIcon iconName="CgAttachment" size={11} />
                            </span>
                            <span className=" fw-semibold" style={{ color: "#391F84", fontSize: "12px" }}>
                                Attachments
                            </span>
                        </div> */}
                        {orderNo && <Attachment doctype="Sales Order" docname={orderNo} />}

                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    {/* className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px",  height: "70vh",overflowY: "scroll"}} */}
                    <div className="col-3 sidebarbox" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}>
                        <Tab1 
                        sodate={{date:sodate}}
                        setTab1Data={setTab1Data} 
                        orderNo={orderNo} 
                        fullData={fullData}
                        fieldErrors={fieldErrors} 
                        activityboll={activityboll} 
                        setTab1CustomerData={setTab1CustomerData}
                         pTerms={{ paymentterm: paymentterm, setpaymentterm: setpaymentterm, list: p_term?.data }} 
                         price={{ list: pricelist?.data, setvalue: setpricel, value: pricel }}
                         currency={{ list: currencylist?.data, setvalue: setcurrency, value: currency }}
                         taxandchanges={{ list: taxandchangeslist?.data, setvalue: settaxandchanges, value: taxandchanges }}
                         termandcondition={{ termsandcondition, settermsandcondition, list: tandc?.data }}
                         cost_center={{ list: costcenterlist?.data, setvalue: setcost_center, value: cost_center }}
                         project={{ list: projectlist?.data, setvalue: setproject, value: project }}
                        />
                    </div>
                    {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>

                        {/* <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}> */}
                        <div className="d-flex pb-2" style={{ gap: '5px' }}>
                            <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {selected_item_data.length}</span></p>
                            <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {totalQuantity}</span></p>

                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table 
                        setselected_item_data={setselected_item_data} 
                        rows={rows} 
                        setRows={setRows} 
                        list_data={getitem_list_data} 
                        po_status={po_response}
                        fullData={fullData}
                        />

                        <div className=" mt-auto pb-1" style={{ display: po_response.data ? '' : 'none' }}>

                            {/* <div className="row">
                                <div className="col-3">
                                    <p className="TotalQtywithoutBg">Ordered Quantity -  <span className="px-2" style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Taxable Value - <span className="px-2" style={{ color: '#FF5969' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.selling_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Tax - <span className="px-2" style={{ color: '#2563EB' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.selling_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Total Value - <span className="px-2" style={{ color: '#16A34A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.selling_price), 0)}</span></p>
                                </div>
                            </div> */}


                            <div className="row">
									<div
										className="row"
										style={{ display: "flex", flexWrap: "wrap" }}
									>
										<div style={{ width: "20%" }}>
											<p className="TotalQtywithoutBg">
												Ordered Quantity -
												<span style={{ color: "#EC642A" }}>
													{selected_item_data.reduce(
														(sum, item) => sum + Number(item.quantity),
														0
													)}
												</span>
											</p>
										</div>

										<div style={{ width: "18%" }}>
											<p className="NoOfLinewithoutBg">
												Total Value -
												<span style={{ color: "#FF5969" }}>
                                                    {/* {console.log("check sekekek order is here",selected_item_data)} */}
													{selected_item_data.reduce(
														(sum, item) =>
															sum +
															Number(item.quantity * item.item.selling_price),
														0
													)}
												</span>
											</p>
										</div>

										<div style={{ width: "24%" }}>
											<p className="NoOfLinewithoutBg">
												Tax Type -
												<span style={{ color: "#C40AB8" }}>
													{fullData?.message?.taxes.length == 0
														? ""
														: fullData?.message?.taxes
																.reduce((acc, curr) => {
																	if (!acc.includes(curr.description)) {
																		acc.push(curr.description);
																	}
																	return acc;
																}, [])
																.join(", ")}
												</span>
											</p>
										</div>

										<div style={{ width: "15%" }}>
											<p className="NoOfLinewithoutBg">
												Tax -
												<span style={{ color: "#2563EB" }}>
													{fullData?.message?.total_taxes_and_charges}
												</span>
											</p>
										</div>

										<div style={{ width: "22%" }}>
											<p className="NoOfLinewithoutBg">
												Grand Total -
												<span style={{ color: "#16A34A" }}>
													{/* {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.selling_price), 0)} */}
													{fullData?.message?.grand_total}
												</span>
											</p>
										</div>
									</div>
								</div>
                        </div>
                    </div>
                        : ''}
                    <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px', overflow: tab == 2 ? "" : 'hidden' }}> <Tab2 tab1CustomerData={tab1CustomerData} setTab2Data={setTab2Data} /> </div>
                    {/* <div className="col-12" style={{ visibility: tab == 3 ? "visible" : 'hidden', height: tab == 3 ? "auto" : '0px', overflow: tab == 3 ? "" : 'hidden' }} > <Tab3 /> </div>
                    <div className="col-12" style={{ visibility: tab == 4 ? "visible" : 'hidden', height: tab == 4 ? "auto" : '0px', overflow: tab == 4 ? "" : 'hidden' }}> <Tab4 /> </div> */}
                </div>
            </div>

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />
            <BulkUpload
                show={showpopup}
                onClose={() => setShowpopup(false)}
                rows={rows}
                setRows={setRows}
                setselected_item_data={setselected_item_data}
            />

        </>
    )
}

export default Salesform
